import { render, staticRenderFns } from "./DetailsTable.vue?vue&type=template&id=27fe886a&scoped=true&"
import script from "./DetailsTable.vue?vue&type=script&lang=js&"
export * from "./DetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./DetailsTable.vue?vue&type=style&index=0&id=27fe886a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fe886a",
  null
  
)

export default component.exports